import {
  Step,
  StepperComponentStateType,
  StepperContentType,
} from '@unifyapps/defs/blocks/Stepper/types';

export const getBlockSteps = (blockState: StepperComponentStateType) => {
  let steps: Step[] = [];
  if (blockState.content.type === StepperContentType.DYNAMIC) {
    steps = blockState.steps ?? [];
  } else {
    steps = blockState.content.steps ?? [];
  }
  return steps;
};
